import { ActionFunctionArgs } from "react-router-dom";
import { reinviteUser } from "@/api/jobilla-users";

export async function action({ params }: ActionFunctionArgs) {
  if (!params.user) {
    return {
      status: 404,
    };
  }

  try {
    await reinviteUser(+params.user);
    return { status: 200 };
  } catch (error) {
    return { status: 500 };
  }
}
